export class CMySprite {
    private m_com:fgui.GComponent;
    private m_obj:fgui.GObject;

    constructor(com:fgui.GComponent) {
        this.m_com = com;
    }

    public Show(objName:string, tm:number, dm:number = 0, callback:Function = null, v:number = 0):void {
        this.m_obj = this.m_com.getChild(objName) as fgui.GObject;
        this.m_obj.visible = true;
        createjs.Tween.get(this.m_obj)
                    .wait(dm)
                    .to({visible:true}, tm)
                    .to({visible:false}, 100)
                    .call(function(){
                        if( callback ) callback(v);
                    })
    }
}